import { cn } from '../lib/utils'

/** The Clearpol wordmark. `inverted` renders it white for the navy sidebar. */
export function ClearpolLogo({ className, inverted = false }: { className?: string; inverted?: boolean }) {
  return (
    <img
      src="/clearpol-logo.svg"
      alt="Clearpol"
      width={875}
      height={222}
      className={cn('h-7 w-auto select-none', inverted && 'brightness-0 invert', className)}
      draggable={false}
    />
  )
}

/** Microsoft's four-square logo mark, as required on "Sign in with Microsoft" buttons. */
export function MicrosoftLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
  )
}
